import { SvgIcon, type SvgIconProps } from '@mui/material';

export const ExploreAppIcon = (props: SvgIconProps) => (
    <SvgIcon
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M19.9394 4.93942C19.8005 4.79968 19.6352 4.68889 19.4532 4.61346C19.2712 4.53803 19.076 4.49946 18.8789 4.5H12.75V1.5H11.25V9H5.12108C4.92403 8.99946 4.72884 9.03803 4.5468 9.11346C4.36476 9.18889 4.1995 9.29968 4.06058 9.43943L1.5 12L4.06058 14.5606C4.1995 14.7003 4.36476 14.8111 4.5468 14.8865C4.72884 14.962 4.92403 15.0005 5.12108 15H11.25V22.5H12.75V10.5H18.8789C19.076 10.5005 19.2712 10.462 19.4532 10.3865C19.6352 10.3111 19.8005 10.2003 19.9394 10.0606L22.5 7.5L19.9394 4.93942ZM5.12108 13.5L3.62108 12L5.12108 10.5H11.25V13.5H5.12108ZM18.8789 9H12.75V6H18.8789L20.3789 7.5L18.8789 9Z"
            fill="black"
        />
    </SvgIcon>
);
